import React, { useState, useEffect } from 'react';

export const PromoModal = ({ isOpen, onClose, onSubmit, initialData = null }) => {
  const [code, setCode] = useState('');
  const [disc, setDisc] = useState('');
  const [endDate, setEndDate] = useState('');

  useEffect(() => {
    if (initialData) {
      setCode(initialData.code || '');
      setDisc(initialData.disc || '');
      setEndDate(initialData.endDate ? initialData.endDate.slice(0, 10) : '');
    } else {
      setCode('');
      setDisc('');
      setEndDate('');
    }
  }, [initialData]);

  const handleSubmit = () => {
    if (!code || !disc) {
      alert('Введите код и скидку');
      return;
    }

    const promoData = {
      code,
      disc: Number(disc),
      ...(endDate && { endDate }),
    };

    onSubmit(promoData);
  };

  if (!isOpen) return null;

  return (
    <div style={modalStyles}>
      <div style={modalContentStyles}>
        <input
          type="text"
          value={code}
          onChange={(e) => setCode(e.target.value)}
          placeholder="Код промокода"
          style={inputStyles}
        />
        <input
          type="number"
          value={disc}
          onChange={(e) => setDisc(e.target.value)}
          placeholder="Скидка (%)"
          style={inputStyles}
        />
        <input
          type="date"
          value={endDate}
          onChange={(e) => setEndDate(e.target.value)}
          style={inputStyles}
        />

        <div style={buttonContainerStyles}>
          <button onClick={handleSubmit} style={buttonStyles}>
            {initialData ? 'Сохранить' : 'Добавить'}
          </button>
          <button onClick={onClose} style={buttonStyles}>
            Закрыть
          </button>
        </div>
      </div>
    </div>
  );
};

// Стили
const modalStyles = {
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: 1000,
};

const modalContentStyles = {
  backgroundColor: 'white',
  padding: '20px',
  borderRadius: '8px',
  width: '400px',
  maxHeight: '90%',
  overflowY: 'auto',
  textAlign: 'center',
};

const inputStyles = {
  width: '100%',
  padding: '10px',
  margin: '5px 0',
  borderRadius: '5px',
  border: '1px solid #ccc',
};

const buttonContainerStyles = {
  display: 'flex',
  justifyContent: 'space-between',
  marginTop: '10px',
};

const buttonStyles = {
  padding: '10px',
  borderRadius: '5px',
  border: '1px solid #ccc',
  cursor: 'pointer',
};